import { lazyLogDatapoint } from 'owa-analytics';
import UsageDatapoint from 'owa-analytics/lib/datapoints/UsageDatapoint';
import type { CustomData } from 'owa-analytics-types';
import type { SonoraEntityType, SonoraViewState } from 'owa-editor-sonora-types';
import convertSetToString from '../utils/convertSetToString';

export default function logSonoraDatapoint(
    viewState: SonoraViewState,
    datapointName: string,
    customData: CustomData
): void {
    logSimpleSonoraDatapoint(datapointName, {
        sessionId: viewState.sessionId,
        sequenceId: viewState.sequenceId,
        isEmptyQuery: viewState.queryString.length === 0,
        intentDetectionHintShown: convertSetToString<SonoraEntityType>(
            viewState.intentDetectionHintShown
        ),
        intentDetectionHintAccepted: viewState.intentDetectionHintAccepted,
        ...customData,
    });
}

export function logSimpleSonoraDatapoint(
    datapointName: string,
    customData: CustomData,
    cosmosOnlyData?: string
): void {
    const datapoint = new UsageDatapoint(datapointName, customData, {
        isCore: true,
        excludeFromKusto: true,
    });

    if (cosmosOnlyData) {
        datapoint.addCosmosOnlyData(cosmosOnlyData);
    }

    lazyLogDatapoint.importAndExecute(datapoint);
}
